//dependencias
import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { Link } from "react-router-dom";
import RingLoader from "react-spinners/ScaleLoader";

//componentes
import "./facturaNEPagadasNF.css";
import Alert from "../../modal/alert";

/** En false se ocultan simulación PDF y "solo 1 recibo" (producción). */
const MOSTRAR_HERRAMIENTAS_PRUEBA = false;

class FacturaNEPagadasNF extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mes: [],
      anio: [],
      codigo3: "",
      codigo4: "",
      prueba: false, // true = solo genera 1 recibo (primer paciente) para verificar
      mensajealerta: false,
      tituloM: "",
      cuerpoM: "",
      loading: false,
      generandoRecibos: false,
    };
  }

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleClose = () => {
    this.setState({ mensajealerta: false });
  };

  limpiar = () => {
    this.setState({
      codigo3: "",
      codigo4: "",
      mensajealerta: false,
      tituloM: "",
      cuerpoM: "",
    });
  };

  cargarFechas = () => {
    let config = {
      headers: {
        "Content-Type": "text/html",
      },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/fecha.php";
    axios.post(xurl, null, config).then((res) => {
      if (res.data.variable1) {
        let xmes = res.data.variable1;
        let xanio = res.data.variable2;
        this.setState({
          mes: xmes,
          anio: xanio,
        });
      }
    });
  };

  componentDidMount() {
    this.cargarFechas();
  }

  consultarReporte = () => {
    if (this.state.codigo3.length > 0 && this.state.codigo4.length > 0) {
      let data = new FormData();
      data.append("mes", this.state.codigo3);
      data.append("anio", this.state.codigo4);
      axios({
        method: "post",
        url:
          "https://institutobilinguelasnaciones.com/terapias/fpdf/reportes/facturaNEPagadasNF.php",
        responseType: "arraybuffer",
        data: data,
      }).then(function (response) {
        let blob = new Blob([response.data], { type: "application/pdf" });
        var fileURL = URL.createObjectURL(blob);
        window.open(fileURL);
      });
    } else {
      this.setState({
        mensajealerta: true,
        tituloM: "Facturar N/E Pagadas No Facturadas",
        cuerpoM:
          "Debe seleccionar un mes y un año para generar el reporte, gracias...",
      });
    }
  };

  reporteNEPFacturadas = () => {
    if (this.state.codigo3.length > 0 && this.state.codigo4.length > 0) {
      this.setState({ loading: true });
      let data = new FormData();
      data.append("mes", this.state.codigo3);
      data.append("anio", this.state.codigo4);
      axios({
        method: "post",
        url:
          "https://institutobilinguelasnaciones.com/terapias/fpdf/reportes/reporteNEPFacturadas.php",
        responseType: "arraybuffer",
        data: data,
      })
        .then((response) => {
          let blob = new Blob([response.data], { type: "application/pdf" });
          var fileURL = URL.createObjectURL(blob);
          window.open(fileURL);
          this.setState({ loading: false });
        })
        .catch(() => {
          this.setState({
            loading: false,
            mensajealerta: true,
            tituloM: "Facturar N/E Pagadas No Facturadas",
            cuerpoM:
              "Error de conexión al generar el reporte de N/E pagadas facturadas.",
          });
        });
    } else {
      this.setState({
        mensajealerta: true,
        tituloM: "Facturar N/E Pagadas No Facturadas",
        cuerpoM:
          "Debe seleccionar un mes y un año para generar el reporte, gracias...",
      });
    }
  };

  simularRecibosPDF = () => {
    if (this.state.codigo3.length > 0 && this.state.codigo4.length > 0) {
      this.setState({ loading: true });
      let data = new FormData();
      data.append("mes", this.state.codigo3);
      data.append("anio", this.state.codigo4);
      if (this.state.prueba) data.append("prueba", "1");
      axios({
        method: "post",
        url:
          "https://institutobilinguelasnaciones.com/terapias/fpdf/reportes/simularFacturaNEPagadasNF.php",
        responseType: "arraybuffer",
        data: data,
      })
        .then((response) => {
          let blob = new Blob([response.data], { type: "application/pdf" });
          var fileURL = URL.createObjectURL(blob);
          window.open(fileURL);
          this.setState({ loading: false });
        })
        .catch((err) => {
          const detalle = err.code === "ECONNABORTED"
            ? "La operación tardó demasiado (timeout)."
            : (err.response
              ? ("HTTP " + err.response.status)
              : (err.message || ""));
          this.setState({
            loading: false,
            mensajealerta: true,
            tituloM: "Simular recibos (PDF)",
            cuerpoM: "Error al generar la simulación en PDF." + (detalle ? " " + detalle : ""),
          });
        });
    } else {
      this.setState({
        mensajealerta: true,
        tituloM: "Simular recibos (PDF)",
        cuerpoM: "Debe seleccionar un mes y un año para simular los recibos.",
      });
    }
  };

  generarRecibos = () => {
    if (this.state.generandoRecibos) {
      return;
    }
    if (!this.state.codigo3 || this.state.codigo3.length === 0 || !this.state.codigo4 || this.state.codigo4.length === 0) {
      this.setState({
        mensajealerta: true,
        tituloM: "Facturar N/E Pagadas No Facturadas",
        cuerpoM: "Debe seleccionar un mes y un año para generar los recibos.",
      });
      return;
    }
    this.setState({ generandoRecibos: true });
    const data = new FormData();
    data.append("boton", "facturarNEPagadas");
    data.append("mes", this.state.codigo3);
    data.append("anio", this.state.codigo4);
    if (this.props.usuario1 && this.props.usuario1.password) {
      data.append("claveUsu", this.props.usuario1.password);
    }
    if (MOSTRAR_HERRAMIENTAS_PRUEBA && this.state.prueba) {
      data.append("prueba", "1");
    }
    axios({
      method: "post",
      url: "https://institutobilinguelasnaciones.com/terapias/backend/facturaNEPagadasNF.php",
      data: data,
      // Debe ser >= tiempo real del PHP (muchos pacientes + locks DB); 2 min cortaba y el servidor seguía con GET_LOCK.
      timeout: 600000, // 10 minutos
    })
      .then((res) => {
        const ok = res.data && res.data.variable1;
        const msg = res.data && res.data.variable2 ? res.data.variable2 : (ok ? "Recibos generados." : "Error al generar recibos.");
        const cantidad = res.data && res.data.variable3 != null ? res.data.variable3 : null;
        this.setState({
          mensajealerta: true,
          tituloM: "Generar recibos",
          cuerpoM: cantidad != null ? msg + " (" + cantidad + " recibo(s))." : msg,
        });
      })
      .catch((err) => {
        const detalle = err.code === "ECONNABORTED"
          ? "La operación tardó demasiado (timeout)."
          : (err.response && err.response.data && typeof err.response.data === "string"
            ? err.response.data.slice(0, 150)
            : (err.message || ""));
        this.setState({
          mensajealerta: true,
          tituloM: "Generar recibos",
          cuerpoM: "Error de conexión al generar los recibos." + (detalle ? " " + detalle : ""),
        });
      })
      .finally(() => {
        this.setState({ generandoRecibos: false });
      });
  };

  render() {
    return (
      <div className="principal-pago row">
        <div className="contenedor-pago1 col-12">
          <div className="titulo-pago ">
            <p>FACTURAR NOTAS DE ENTREGA PAGADAS NO FACTURADAS</p>
          </div>
          {this.state.mensajealerta === true && (
            <Alert
              tituloMensaje={this.state.tituloM}
              cuerpoMensaje={this.state.cuerpoM}
              open={this.state.mensajealerta}
              handleClose={this.handleClose}
            />
          )}
          {(this.state.loading || this.state.generandoRecibos) && (
            <div className="cont-spinner row">
              <div className="spinner col-6">
                <RingLoader
                  clasName="spinner"
                  sizeUnit={"px"}
                  size={160}
                  width={19}
                  radius={20}
                  height={160}
                  color={"#48e120"}
                  loading={this.state.loading || this.state.generandoRecibos}
                />
              </div>
            </div>
          )}

          <div className="contenedorp row">
            <div className="titulo-planillai col-12">
              <p>SELECCIONE EL MES Y EL AÑO.</p>
            </div>
            <div className="row">
              <div className="fechas col-12">
                <select
                  id="codigo3"
                  name="codigo3"
                  value={this.state.codigo3}
                  onChange={this.onChange}
                >
                  <option>--Mes--</option>
                  {this.state.mes.map((item) => {
                    return (
                      <option key={item.variable1} value={item.variable1}>
                        {item.variable2}
                      </option>
                    );
                  })}
                </select>
                <select
                  id="codigo4"
                  name="codigo4"
                  value={this.state.codigo4}
                  onChange={this.onChange}
                >
                  <option>--Año--</option>
                  {this.state.anio.map((item) => {
                    return (
                      <option key={item.variable1} value={item.variable1}>
                        {item.variable1}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>

            <div className="xcontenedorcedula1 col-12">
              {MOSTRAR_HERRAMIENTAS_PRUEBA && (
                <label className="mr-2">
                  <input
                    type="checkbox"
                    name="prueba"
                    checked={this.state.prueba}
                    onChange={(e) => this.setState({ prueba: e.target.checked })}
                  />
                  <span className="ml-1">Solo 1 recibo (1ro. en Lista)</span>
                </label>
              )}
              <button
                className="boton"
                onClick={this.consultarReporte}
              >
                Consultar
              </button>
              <button
                type="button"
                className="boton"
                onClick={this.generarRecibos}
                disabled={this.state.generandoRecibos}
              >
                {this.state.generandoRecibos ? "Generando recibos…" : "Generar recibos"}
              </button>
              {MOSTRAR_HERRAMIENTAS_PRUEBA && (
                <button className="boton" onClick={this.simularRecibosPDF}>
                  Simular recibos (PDF)
                </button>
              )}
              <button
                className="boton"
                onClick={this.reporteNEPFacturadas}
              >
                Reporte facturadas
              </button>
              <Link to="/">
                <button className="boton">Salir</button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    usuario1: state.usuario1,
    token: state.token,
  };
};

export default connect(mapStateToProps)(FacturaNEPagadasNF);

